import { LoadingService } from './../service/loading-service';
import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { MsgService } from './../service/msg.service';
import { AuthService } from '../service/auth.service'; // aqui o novo serviço

@Injectable()
export class HttpInterceptorImpl implements HttpInterceptor {
  private readonly router = inject(Router);
  private readonly msgService = inject(MsgService);
  private readonly authService = inject(AuthService);
  private readonly loadingService = inject(LoadingService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.deveExibirLoading(req)) {
      this.loadingService.start();
    }

    const authorization = this.montarAuthorization(req);
    const contentType = req.headers.get('Content-Type') || 'application/json';
    const ehFormData = typeof FormData !== 'undefined' && req.body instanceof FormData;
    const omitirContentType = ehFormData || req.headers.has('hide-content-type');
    let headers = req.headers
      .delete('hide-content-type')
      .set('Authorization', authorization)
      .set('Sistema', 'LOT');

    if (!omitirContentType) {
      headers = headers.set('Content-Type', contentType);
    } else {
      headers = headers.delete('Content-Type');
    }

    const newRequest = req.url.includes('https://viacep')
      ? req
      : req.clone({
          headers,
          url:
            req.url.startsWith('data:') || req.url.startsWith('http')
              ? req.url
              : environment.urlBase + req.url,
        });

    return next.handle(newRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.loadingService.stop();
        }
      }),
      catchError((err) => this.handleError(err, req))
    );
  }

  private deveExibirLoading(req: HttpRequest<any>): boolean {
    return (
      !req.url.includes('/node_modules_echarts_index_js.js') &&
      !req.url.includes('/actuator') &&
      req.headers.get('no-loading') !== 'true'
    );
  }

  private montarAuthorization(req: HttpRequest<any>): string {
    if (req.url.includes('/public/sincronizacao')) {
      return this.authService.token() == null
        ? ''
        : 'Bearer ' + this.authService.token();
    } else if (
      !req.url.includes('/public/') &&
      !req.url.includes('/actuator')
    ) {
      return this.authService.token() == null
        ? ''
        : 'Bearer ' + this.authService.token();
    }
    return '';
  }

  private handleError(response: any, req: HttpRequest<any>): Observable<never> {
    if (
      response.statusText === 'Unknown Error' &&
      !req.url.includes('https://viacep') &&
      !req.url.includes('/actuator')
    ) {
      const usuarioLogado = this.authService.getUsuarioLogado();
      if (usuarioLogado) {
        this.router.navigate([`${usuarioLogado.prefixoGrupo}/error`]);
        localStorage.setItem('exibirTelaErro', 'true');
      }
      this.loadingService.stop();
      return throwError(() => response);
    }

    if (
      response instanceof HttpErrorResponse &&
      !req.url.includes('https://viacep') &&
      !req.url.includes('/actuator')
    ) {
      if (response.status === 401) {
        this.authService.excluirToken();
        this.router.navigate(['/sessao-expirada']);
      }

      // ⬇️ Nova lógica para extrair e mostrar mensagem customizada
      const erroBack = response.error;
      const mensagemErro =
        erroBack?.detalhe ||
        erroBack?.message ||
        'Desculpe, ocorreu um erro inesperado. Tente novamente mais tarde ou contate o suporte.';

      if (response.status === 500 && !req.url.includes('verificar-senha/')) {
        this.msgService.msgErro(mensagemErro);
      }

      if (response.status === 0) {
        this.msgService.msgErro(
          'Erro de conexão com o servidor. Verifique sua internet ou tente mais tarde.'
        );
      }
    }

    this.loadingService.stop();
    return throwError(() => response);
  }
}
